<template>
  <ViewCustomData entityName="facility" entitySpec="data" serviceName="BaseService" :columns="FACILITY_COLUMNS"
    scrollHeight="770px" :dictionary="FACILITY_DICTIONARY" @selectedRow="onSelectedRow" :rows="52"
    :dialog="facilityDialog" :prepareData="prepareData" ref="viewFacilityData">
    <template #toolbar>
      <Button label="Экспорт Excel" class="ml-4" icon="pi pi-file-excel" @click="onExportExcel" severity="success" />
    </template>
  </ViewCustomData>
</template>

<script setup>
import { ref, shallowRef } from 'vue';
import FacilityDialog from './FacilityDialog';
import { exportExcel } from '@/core/utils/ExportExcel';
import { FACILITY_DICTIONARY, FACILITY_COLUMNS } from './facilityConstants';

const dataExcel = ref([]);
const facilityDialog = shallowRef(FacilityDialog);
const selected = ref(null);

const mode = ref([
  { id: 1, name: 'Актуал' },
  { id: 2, name: 'Тест (не сохр)' },
  { id: 3, name: 'Не актуал' },
]);

const viewFacilityData = ref(null);

const onSelectedRow = (value) => {
  selected.value = value;
}

const onExportExcel = () => {
  exportExcel({
    fileName: 'facility.xlsx',
    tableData: dataExcel.value || [],
    tableColumns: FACILITY_COLUMNS,
  });
}

const prepareData = (facilities) => {
  dataExcel.value = facilities.map((item) => ({
    ...item,
    facility_mode_id: mode.value.find((m) => m.id === item.facility_mode_id)?.name,
  }));
  return facilities;
}

</script>
